import { AudienceAdapter as i } from "../../audience/audience.adapter.js";
import { Adapter as o, getAdapter as t } from "../../../adapter.js";
import { ScopeAdapter as d } from "../../scope/scope.adapter.js";
import { LoyaltyProgrammeValidityScheduleAdapter as n } from "./loyaltyProgrammeValiditySchedule/loyaltyProgrammeValiditySchedule.adapter.js";
import { LoyaltyProgrammeConfigurationAdapter as a } from "./loyaltyProgrammeConfiguration/loyaltyProgrammeConfiguration.adapter.js";
import { LoyaltyProgrammeModel as p } from "./loyaltyProgramme.model.js";
class f extends o {
  adapt(e) {
    const r = t(i);
    return new p({
      id: e.id,
      name: e.name,
      status: e.status,
      weight: e.weight,
      description: e.description,
      triggerCondition: e.trigger_condition,
      startDate: e.start_date ? new Date(e.start_date * 1e3) : void 0,
      endDate: e.end_date ? new Date(e.end_date * 1e3) : void 0,
      configuration: t(a).adapt(e.configuration),
      scope: t(d).adapt(e.scope),
      audience: (e.audience ?? []).map(r.adapt),
      validitySchedule: e.validity_schedule ? t(n).adapt(e.validity_schedule) : void 0
    });
  }
  serialize(e) {
  }
}
export {
  f as LoyaltyProgrammeAdapter
};
//# sourceMappingURL=loyaltyProgramme.adapter.js.map
